import React from 'react'
// import defaultImage from '../../lib/images/default-back.jpg'
import defaultUserThumb from '../../lib/images/user-thumb-default.png'
import loadingImage from '../../lib/images/loading.gif'
import { Link } from 'react-router-dom'
import * as SG from '../../constants/Routing'

export default class Component extends React.Component {
  render = () => {

    // const userThumb = defaultUserThumb
    const circle = this.props.circle
 
    if (!!circle) {
      let memberDisplay

      // console.log('circle', circle)

      if (circle.member_limit === 0) {
        memberDisplay = (
          <div className='circle-member-count'><i className="material-icons">people</i>{circle.member_count}/(無制限) 人</div>
        )
      } else {
        memberDisplay = (
          <div className='circle-member-count'><i className="material-icons">people</i>{circle.member_count}/{circle.member_limit}人</div>
        )
      }

      let joinBtn
      // console.log('card', circle)
      const joinedStatus = circle.joined_status
      // console.log('サークル', circle, joinedStatus)
      switch (joinedStatus) {
        case 'applied':
          joinBtn = (
            <span className='btn btn-submit disabled'><i className="material-icons">add</i>申請済み</span>
          )
          break;
        case 'approved':
          joinBtn = (
            <span className='btn btn-submit disabled'>
              <i className="material-icons">add</i>参加中
              </span>
          )
          break
        case 'own':
          joinBtn = (
            <span className='btn btn-submit disabled'>
              my サークル
              </span>
          )
          break
        default:
          joinBtn = (
            <span className='btn btn-submit'><i className="material-icons">add</i>参加する</span>
          )
          break;
      }
      return (
        <section className='col-12 col-sm-6 col-md-4 col-lg-3'>
          <div className='community-card'>
            <Link to={SG.COMMUNITY_PATH.replace(/:id/, circle.id)}>
              <div className='community-catch' style={{ backgroundImage: `url(${circle.photo})` }}></div>
              <div className='community-body'>
                <h2 className='community-headline'>{circle.name}</h2>
                <div>
                  <div className='circle-price'><i className="material-icons">attach_money</i>{circle.price}円/月</div>
                  {memberDisplay}
                  {joinBtn}
                </div>
              </div>
            </Link>
          </div>
        </section>
      )
    } else {
      return (
        <section className='col-12 col-sm-6 col-md-4 col-lg-3'>
          <div className='community-card'>
            <Link to={SG.COMMUNITY_PATH.replace(/:id/, '')}>
              <div className='community-catch' style={{ backgroundImage: `url(${loadingImage})` }}></div>
              <div className='community-body'>

              </div>
            </Link>
          </div>
        </section>
      )
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/Community/Card.jsx